import { render, staticRenderFns } from "./favorites-count.vue?vue&type=template&id=d63cc53c&"
import script from "./favorites-count.vue?vue&type=script&lang=js&"
export * from "./favorites-count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports